import { waitDebounce } from '../../_common/js/_helpers/wait-debounce';

window.addEventListener('load', event => {
    // Mobile nav
    let mobileNavToggle = document.getElementById('mobileNavToggle');
    let mobileNavigation = document.getElementById('mobileNavigation');
    let mobileNavDropdownToggle = document.querySelectorAll('.mobile-nav-dropdown-toggle');

    if (mobileNavToggle) {
        mobileNavToggle.addEventListener('click', () => {
            mobileNavToggle.classList.toggle('active');

            if (mobileNavigation) {
                mobileNavigation.classList.toggle('active');
                document.documentElement.classList.toggle('body-lock-scroll');
            }

            for (let navDropdown of mobileNavDropdownToggle) {
                let mobileNavDropdownContent = navDropdown.closest('li').nextElementSibling;
                navDropdown.querySelector('svg').classList.remove('-scale-x-100');
                mobileNavDropdownContent.classList.add('!max-h-0');
                mobileNavDropdownContent.classList.remove('opacity-100');
            }
        });
    }

    for (let navDropdown of mobileNavDropdownToggle) {
        let mobileNavDropdownContent = navDropdown.closest('li').nextElementSibling;
        navDropdown.addEventListener('click', () => {
            navDropdown.querySelector('svg').classList.toggle('-scale-x-100');
            mobileNavDropdownContent.classList.toggle('!max-h-0');
            mobileNavDropdownContent.classList.toggle('opacity-100');
        });
    }

    // Desktop nav
    let desktopNavToggle = document.getElementById('desktopNavToggle');
    let siteHeader = document.getElementById('siteHeader');
    let navTopPaddingDesktop = document.getElementById('navTopPaddingDesktop');
    const scrollNavigation = document.getElementById('top-of-site-pixel-anchor');
    let clickCloseCatchWrapper = document.getElementById('clickCloseCatchWrapper');
    let desktopNavDropdownContent = document.querySelectorAll('.desktop-nav-dropdown-content');

    // Keeps land dropdown nav hidden for 500ms on page load to mask transitions
    for (let navDropdown of desktopNavDropdownContent) {
        setTimeout(function() {
            navDropdown.classList.remove('hidden');
        }, 500);
    }

    if (desktopNavToggle && scrollNavigation && siteHeader && navTopPaddingDesktop && clickCloseCatchWrapper) {
        desktopNavToggle.addEventListener('click', () => {
            desktopNavToggle.classList.toggle('active');
            siteHeader.classList.toggle('active');
            clickCloseCatchWrapper.classList.toggle('active');

            // Add scroll listener when button is open to close menu
            window.addEventListener('scroll', scrollListener);
        });

        // Track click outside the desktop nav, if click off nav close nav
        clickCloseCatchWrapper.addEventListener('click', () => {
            desktopNavToggle.classList.remove('active');
            siteHeader.classList.remove('active');
            clickCloseCatchWrapper.classList.remove('active');
            window.removeEventListener('scroll', scrollListener);
        });

        if (
            'IntersectionObserver' in window &&
            'IntersectionObserverEntry' in window &&
            'intersectionRatio' in window.IntersectionObserverEntry.prototype
        ) {
            const callback = function(entries) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('pixel-observed');
                        desktopNavToggle.classList.add('visible');
                        siteHeader.classList.add('header-fixed');
                        navTopPaddingDesktop.classList.add('header-fixed');

                        setTimeout(function() {
                            siteHeader.classList.add('transition');
                        }, 150);
                    } else {
                        entry.target.classList.remove('pixel-observed');
                        desktopNavToggle.classList.remove('visible');
                        siteHeader.classList.remove('header-fixed');
                        siteHeader.classList.remove('transition');
                        navTopPaddingDesktop.classList.remove('header-fixed');

                        // Remove scroll listener
                        window.removeEventListener('scroll', scrollListener);
                    }
                });
            };

            const observer = new IntersectionObserver(callback);
            const anchor = document.getElementById('top-of-site-pixel-anchor');

            observer.observe(anchor);
        }
    }


    // Hide desktop nav on scroll
    const scrollDebouncer = waitDebounce((event, scrollDuration) => {
        if (scrollDuration > 300) {
            window.removeEventListener('scroll', scrollListener);
            desktopNavToggle.classList.remove('active');
            siteHeader.classList.remove('active');
            clickCloseCatchWrapper.classList.remove('active');
        }
    }, 100, false);

    const scrollListener = (event) => {
        scrollDebouncer(event);
    };
});